// src/utils/smsGateway.js
import Cookies from "js-cookie";
import { normalizePhone, toShortRefFront } from "./format";
import { getDisplayName } from "./displayName";
import { meldSmsSendt } from "./smsStatus";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

/**
 * Send en SMS via backend (POST /sms/send), som kaller Vianett
 * @param {object} param0
 * @returns {Promise<boolean>} success
 */
export async function sendSms({
  phone,
  name = "kunde",
  statusLabel = null,
  message,
  sender = "Sporten",
  // Valgfrie: hvilken kunde og sak SMS-en gjelder, så den havner i riktig historikk.
  customerId,
  serviceRef,
}) {
  if (!phone) {
    console.warn("SMS: mangler telefonnummer");
    return false;
  }

  const normalized = normalizePhone(phone);

  if (!normalized || normalized.length !== 8) {
    console.warn(`SMS: ugyldig nummer («${phone}» → «${normalized}»)`);
    return false;
  }

  const prefix = statusLabel ? `Status oppdatert til: ${statusLabel}. ` : "";
  const body = (message != null ? message : prefix).trim();

  if (!body) {
    console.warn("SMS: tom melding");
    return false;
  }

  try {
    const resp = await fetch(`${API_BASE_URL}/sms/send`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // Serveren arkiverer SMS-en (arkiver: true), se POST /sms/send.
      body: JSON.stringify({
        tel: normalized,
        message: body,
        sender,
        arkiver: true,
        kundeNavn: name,
        butikkid: parseInt(Cookies.get("butikkid"), 10) || 0,
        ...(customerId && { customerId: String(customerId) }),
        ...(serviceRef && { serviceRef: String(serviceRef) }),
      }),
    });

    if (!resp.ok) {
      console.error("SMS-feil:", resp.status);
      return false;
    }

    meldSmsSendt();
    return true;
  } catch (err) {
    console.error("Feil ved SMS-sending:", err);
    return false;
  }
}

/**
 * Send varsel-SMS når verkstedet skriver ny dialogmelding
 */
export async function notifyCustomerNewDialogMessage({
  svc,
  text,
  customerName,
  customerPhone,
  customerLink,
  produkt,
}) {
  const clean = (text || "").trim();
  if (!clean) return;

  if (!customerLink) {
    console.warn("notifyDialog: mangler kundelenke");
    return;
  }
  if (!customerPhone) {
    console.warn("notifyDialog: mangler telefonnummer");
    return;
  }

  const storeName = produkt?.butikk || getDisplayName();
  const shortRef = toShortRefFront(svc?.serviceRef);
  const greeting = "Hei,";
  const refPart = shortRef ? ` (ref: ${shortRef})` : "";

  const body = [
    greeting,
    `Du har fått en ny melding angående din service${refPart}:`,
    `"${clean}"`,
    "",
    `Se dialogen her:\n${customerLink}`,
    "",
    `Mvh ${storeName}`,
  ].join("\n");

  return sendSms({
    phone: customerPhone,
    statusLabel: null,
    message: body,
    customerId: svc?.customerId,
    serviceRef: svc?.serviceRef,
  });
}
